<template>
  <header :class="{ 'scrolled-nav': scrollNav }">
    <nav>
      <div class="logo">
        <router-link to="/">
          <img
            class="logo_svg mt-xxs"
            :src="require('@/assets/logo_col.svg')"
            alt="Logo"
            @click="closeMenu"
          />
        </router-link>
      </div>
      <ul v-show="!mobile" class="navigation">
        <li><router-link class="link" to="/">Home</router-link></li>
        <li><router-link class="link" to="/ueberuns">Über Uns</router-link></li>
        <li><router-link class="link" to="/projekte">Projekte</router-link></li>
        <li>
          <router-link class="link" to="/referenzen">Referenzen</router-link>
        </li>
        <BaseBtn
          variant="emphasized"
          to="mailto:kurt@helpingheads.at?cc=sina@helpingheads.at"
          >Kontakt</BaseBtn
        >
      </ul>
      <div
        @click="toggleMobileNav"
        v-show="mobile"
        class="burger__btn"
        :class="{ burger__active: mobileNav }"
      >
        <h3>Menu</h3>
        <div class="burger">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div v-show="mobileNav" class="mobile__nav">
        <ul class="fullscreen__nav" @click="closeMenu">
          <li>
            <router-link class="mlink" to="/" @click="closeMenu"
              >Home</router-link
            >
          </li>
          <li>
            <router-link class="mlink" to="/ueberuns">Über Uns</router-link>
          </li>
          <li>
            <router-link class="mlink" to="/projekte">Projekte</router-link>
          </li>
          <li>
            <router-link class="mlink" to="/referenzen">Referenzen</router-link>
          </li>
        </ul>
        <div class="mobile__socials">
          <div>
            <ul @click="closeMenu">
              <li>
                <a href="mailto:kurt@helpingheads.at?cc=sina@helpingheads.at"
                  >Kontakt</a
                >
              </li>

              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=100091342603125&locale=de_DE"
                  target="_blank"
                  aria-label="Facebook"
                  >Facebook</a
                >
              </li>
            </ul>
          </div>
          <div>
            <ul @click="closeMenu">
              <li>
                <a
                  href="https://www.instagram.com/helping.heads/"
                  target="_blank"
                  aria-label="Instagram"
                  >Instagram</a
                >
              </li>

              <li>
                <a
                  href="https://www.linkedin.com/in/helping-heads-projektentwicklung-a34154336/"
                  target="_blank"
                  aria-label="LinkedIn"
                  >LinkedIn</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import BaseBtn from "./BaseBtn.vue";

const scrollNav = ref(null);
const mobile = ref(true);
const mobileNav = ref(false);
const windowWidth = ref(null);

const toggleMobileNav = () => {
  mobileNav.value = !mobileNav.value;
};

const closeMenu = () => {
  mobileNav.value = false;
};

const checkScreen = () => {
  windowWidth.value = window.innerWidth;

  if (windowWidth.value <= 768) {
    mobile.value = true;
    return;
  }
  mobile.value = false;
  mobileNav.value = false;
  return;
};

onMounted(() => {
  window.addEventListener("resize", checkScreen);
  checkScreen();
});

onUnmounted(() => {
  window.removeEventListener("resize", checkScreen);
});
</script>

<style scoped lang="scss">
header {
  background-color: $bg--col--07;
  z-index: 99;
  width: 100%;
  position: fixed;
  nav {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: map-get($spaces, "xs") map-get($spaces, "sm");
    @media (min-width: 768px) {
      padding: map-get($spaces, "sm") map-get($spaces, "lg");
    }
    @media (min-width: 1440px) {
      padding: map-get($spaces, "md") map-get($spaces, "xl");
    }
    width: 100%;
    margin: 0 auto;
    .navigation {
      display: flex;
      align-items: center;
      gap: map-get($spaces, "xl");
      flex: 1;
      justify-content: flex-end;
      z-index: 98;
    }

    ul,
    .link {
      color: $text--greyed;
      text-decoration: none;
      list-style-type: none;
      transition: all 0.2s ease-in-out;
      li {
        white-space: nowrap;
      }
      &:hover {
        color: $brand--col;
        transition: all 0.2s ease-in-out;
      }
    }
    .logo {
      display: flex;
      align-items: center;
      flex: 1;
      .logo_svg {
        width: 3em;
      }
    }
    .burger__btn {
      display: flex;
      gap: map-get($spaces, "sm");
      cursor: pointer;
      height: 100%;
      h3 {
        color: $text--greyed;
      }
      .burger {
        display: flex;
        justify-content: center;
        align-self: center;
        flex-direction: column;
        gap: 7px;
        span {
          height: 3px;
          background: $text--greyed;
          width: 40px;
          border-radius: 999px;
        }
      }
    }

    .burger__active {
      span:nth-child(1) {
        opacity: 0;
      }

      span:nth-child(3) {
        opacity: 0;
      }
    }
    .mobile__nav {
      z-index: -1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: $bg--col;
      padding: map-get($spaces, "sm");
      .fullscreen__nav {
        display: flex;
        flex-direction: column;
        gap: map-get($spaces, "xxs");
        .mlink {
          font-size: 3.615rem;
          color: $text--col;
          font-weight: 550;
        }
        margin-bottom: map-get($spaces, "xxxl");
      }
      .mobile__socials {
        gap: map-get($spaces, "xl");
        display: flex;
        li {
          a {
            color: $text--muted;
          }
          margin-bottom: map-get($spaces, "xs");
        }
      }
    }
  }
}
</style>
